import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useSignUpContext } from "../../../context/signup/signupcontext";

interface FinalStep {
  submit: () => void;
  prevStep: () => void;
}

const EmailPassword: React.FC<FinalStep> = ({ submit, prevStep }) => {
  const { setFormData, formData } = useSignUpContext();
  const { register, handleSubmit, reset } = useForm({});
  const [submitted, setSubmitted] = useState(false); // Track submission state

  // Optionally reset form data when navigating back
  React.useEffect(() => {
    reset(formData?.creds); // Reset form fields to saved credentials if they exist
  }, [reset, formData]);

  const onSubmit = (data: any) => {
    setFormData({ creds: data }); // Update formData with new credentials
    setSubmitted(true); // Set flag to indicate the form was submitted
  };

  // Use useEffect to submit after formData is updated
  React.useEffect(() => {
    if (submitted) {
      submit(); // Call submit function after formData is updated
    }
  }, [submitted, submit, formData]); // Listen for changes to `submitted` and `formData`

  return (
    <form className="form" onSubmit={handleSubmit(onSubmit)}>
      <div className="title-container">
        <img
          height="40px"
          src="https://notifygridmedia.s3.us-east-2.amazonaws.com/black+R+transparent.png"
          alt="roloniumlabs logo"
        />
        <h2 className="form-title">Last step</h2>
        <p>Rolonium Account is all you need to access all Rolonium Services.</p>
      </div>

      {/* Email input */}
      <input
        className="form-input"
        type="text"
        {...register("email")}
        placeholder="Email"
      />

      {/* Password input */}
      <input
        className="form-input"
        type="password"
        {...register("password")}
        placeholder="Password"
      />

      <div className="form-actions">
        <button type="button" className="btn" onClick={prevStep}>
          Previous
        </button>
        <button type="submit" className="btn primary-btn">
          Create Account Now
        </button>
      </div>
    </form>
  );
};

export default EmailPassword;
